import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { AnchorButtonsListBlockConfig } from '@front-platform/content-builder';
import { anchorButtonsListBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { AnchorStoreSelector } from '@common/selectors/anchor.selector';
export interface AnchorButtonsListBlockRuntimeConfig {}

export type AnchorButtonsListBlockConfigInput = Partial<
  Omit<AnchorButtonsListBlockConfig, keyof AnchorButtonsListBlockRuntimeConfig> &
    AnchorButtonsListBlockRuntimeConfig
>;
export type AnchorButtonsListBlockResolvedConfig = Omit<
  AnchorButtonsListBlockConfig,
  keyof AnchorButtonsListBlockRuntimeConfig
> &
  Partial<AnchorButtonsListBlockRuntimeConfig>;
export interface AnchorButtonsListBlockContract extends ConfigComponentContract<
  AnchorButtonsListBlockConfigInput,
  AnchorButtonsListBlockResolvedConfig
> {}

@Component({
  selector: 'app-anchor-buttons-list-block',
  templateUrl: './anchor-buttons-list-block.component.html',
  standalone: false,
})
export class AnchorButtonsListBlockComponent implements AnchorButtonsListBlockContract {
  readonly config = input<AnchorButtonsListBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    AnchorButtonsListBlockConfig,
    AnchorButtonsListBlockRuntimeConfig
  >(anchorButtonsListBlockResolveConfig, () => ({ config: this.config() }));
  anchors$ = this.anchorSelector.selectAnchors;
  constructor(private anchorSelector: AnchorStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(AnchorButtonsListBlockComponent, {
  'keyAliases': {},
});
